import instance from '../scorpiusInstance';
import {
  CREATE_APP_ROLE_START,
  CREATE_APP_ROLE_SUCCESS,
  CREATE_APP_ROLE_ERROR,
} from '../types';

export const createAppRoleStart = (orgId, appName) => ({
  type: CREATE_APP_ROLE_START,
  orgId,
  appName,
});

export const createAppRoleSuccess = (orgId, appName, role) => ({
  type: CREATE_APP_ROLE_SUCCESS,
  orgId,
  appName,
  role,
});

export const createAppRoleError = (orgId, appName, error) => ({
  type: CREATE_APP_ROLE_ERROR,
  orgId,
  appName,
  error,
});

/**
 * Creates the user for the given organization's app.
 * @param {String} orgId
 * @param {String} appName
 * @param {Object} role
 * @param {String} role.name
 * @param {Array<String>} role.permissions
 *
 */
export const createAppRole = (orgId, appName, role) => async dispatch => {
  dispatch(createAppRoleStart(orgId, appName));
  try {
    const response = await instance.post(
      `/organizations/${orgId}/${appName}/roles`,
      role,
      { headers: { retry: true } },
    );
    return dispatch(createAppRoleSuccess(orgId, appName, response.data));
  } catch (error) {
    throw dispatch(createAppRoleError(orgId, appName, error));
  }
};

export default createAppRole;
